import { StaffRole, StaffRoleLevels } from "./Staff";

export type PageKey = "DASHBOARD" | "SEARCH" | "ADMINISTRATION" | "LOCATION_ADMINISTRATION" | "REPORTS" | "CLIENT_ALERTS" | "IRRELEVANT_ENTRIES";

export const PAGES_ACCESS_REQUIRED_LEVEL = {
    DASHBOARD: StaffRoleLevels[StaffRole.OWNER],
    SEARCH: StaffRoleLevels[StaffRole.EMPLOYEE],
    REPORTS: StaffRoleLevels[StaffRole.OWNER],
    ADMINISTRATION: StaffRoleLevels[StaffRole.EMPLOYEE],
    LOCATION_ADMINISTRATION: StaffRoleLevels[StaffRole.OWNER],
    CLIENT_ALERTS: StaffRoleLevels[StaffRole.EMPLOYEE],
    IRRELEVANT_ENTRIES: StaffRoleLevels[StaffRole.EMPLOYEE],
};

const PAGE_PATHS = {
    DASHBOARD: ["/", "/dashboard"],
    SEARCH: ["/search"],
    ADMINISTRATION: ["/administration"],
    LOCATION_ADMINISTRATION: ["/administration/location-administration"],
    CLIENT_ALERTS: ["/administration/client-alerts"],
    IRRELEVANT_ENTRIES: ["/administration/irrelevant-entries"],
    REPORTS: ["/reports"],
};

export const getPageKeyFromPathname = (pathname: string): PageKey | null => {
    const normalized = pathname.replace(/\/+$/, "") || "/";
    const match = (Object.entries(PAGE_PATHS) as [PageKey, string[]][])
        .find(([, paths]) => paths.includes(normalized));

    return match ? match[0] : null;
};